import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'razonSocial',
        title: 'razonSocial',
        placeholder: 'Razón Social',
        icon: 'fa-font',
        document_field_type: 'text',
        index:0,
    },
    {
        id: 'fechaRespuesta',
        title: 'fechaRespuesta',
        placeholder: 'Fecha Respuesta',
        icon: 'fa-font',
        document_field_type: 'text',
        index:1
    },
    {
        id: 'formato',
        title: 'formato',
        placeholder: 'Formato',
        icon: 'fa-font',
        document_field_type: 'text',
        index:2
    },
    {
        id: 'actividad',
        title: 'actividad',
        placeholder: 'Actividad',
        icon: 'fa-font',
        document_field_type: 'text',
        index:3
    },
    {
        id: 'folio',
        title: 'folio',
        placeholder: 'Folio',
        icon: 'fa-font',
        document_field_type: 'text',
        index:4
    },
    {
        id: 'actividadesComplementarias',
        title: 'actividadesComplementarias',
        placeholder: 'Actividades Complementarias',
        icon: 'fa-font',
        document_field_type: 'text',
        index:5
    }
];

class DocumentFieldsREPSE extends Component {
    constructor(props) {
        super();
        this.state = {
            indexSelected: null,
            fields: fieldTypes,
            all_fields:fieldTypes
        };
        this.removeIndex = this.removeIndex.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.selected_fields != null) {
            this.setState({
                indexSelected: null,
                fields: props.selected_fields
            })
        }
    }

    onDragEnd = result => {
        if (!result.destination) return;
        for (var i = 0; i < this.state.fields.length; i++) {
            if(this.state.fields[i].index == result.source.index){
                return false;
            }
        }
        if (result.destination.droppableId == 'newField') {
            try {
                const f = {
                    id:fieldTypes[result.source.index].id,
                    document_field_type: fieldTypes[result.source.index].document_field_type,
                    title: fieldTypes[result.source.index].title,
                    index: fieldTypes[result.source.index].index,
                    placeholder: "",
                    required: false
                }
                this.setState(prevState => ({
                    fields: [...prevState.fields, f],
                    indexSelected: prevState.fields.length
                }))
            } catch (error) {
                console.log(error);
            }
        }
    }

    removeIndex(e, index) {
        e.stopPropagation();
        const fields = [...this.state.fields];
        fields.splice(index, 1);
        this.setState({ indexSelected: null, fields: fields });
    }

    render() {
        return (
            <div>
                <div className="card mt-6 p-9">
                    <strong className="mb-3">Información que se solicitará al invitado</strong>
                    <div class="d-flex flex-row">
                        <div>
                            <p>Folio</p>
                        </div>
                        <div class="pl-2">
                            <p class="text-muted">(Este número de Folio se encuentra localizado en la sección DETERMINA)</p>
                        </div>
                    </div>

                    <strong className="mb-3">Información que se extrae de la Opinión de Cumplimiento del REPSE</strong>
                    <div className="card mt-3 p-9 bg-light-light">
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="fields">
                                {(provided) => (
                                    <div className="row align-left" {...provided.droppableProps} ref={provided.innerRef}>
                                        <div className="col-sm-8">
                                            {this.state.fields.map(({id, document_field_type, placeholder}, index) => {
                                                return (<div key={index} className="mb-2">
                                                    <span>
                                                        <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i>
                                                    </span>
                                                    <span className="d-inline-block">
                                                        {placeholder}
                                                    </span>
                                                </div>);
                                            })}

                                        </div>
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentFieldsREPSE;

if (document.getElementById('DocumentFieldsREPSE')) {
    ReactDOM.render(<DocumentFieldsREPSE />, document.getElementById('DocumentFieldsREPSE'));
}
